import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { recToUser } from '__mocks__/mockData/recommendation-data';

const RecommendationApi = [rest.get(`${API_ROOT}recommendation-to-user`, (req, res, ctx) => res(ctx.json(recToUser)))];
export default RecommendationApi;
